import { useState } from 'react';
import SvgIcon from '../../../coreComponents/SvgIcon';
import { Modal } from 'reactstrap';
import FeedBackForm from '../../../components/formsAndTable/forms/feedBackForm/FeedbackForm';
import SimpleModal from '../../../components/uiKits/modal/basicModal/SimpleModal';

const FeedBack = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <>
      {' '}
      <li onClick={() => setShowForm((prev) => !prev)}>
        <div>
          <i className="icon-comment"></i>
        </div>
      </li>
      <SimpleModal size="lg" isOpen={showForm} close={() => setShowForm(false)}>
        <FeedBackForm close={() => setShowForm(false)} />
      </SimpleModal>
    </>
  );
};

export default FeedBack;
